import React from "react";
import { Checkbox, Radio } from "semantic-ui-react";
import styles from "./Table.module.css";

const CustomRadio = React.forwardRef(({ indeterminate, ...rest }, ref) => {
  return <Radio {...rest} ref={ref} className={styles.radio} />;
});

export default CustomRadio;
